import {capitalizeFirstLetters} from "../../misc/helpers";

const allAvailableSubCategories = [
  "Value",
  "Accessory Kits",
  "Bar Centerset Faucets",
  "Bar Faucets",
  "Bath Shower Trim Kits",
  "Bathroom Accessory Parts",
  "Bathroom Faucet Fittings and Spare Parts",
  "Bathroom Faucet Handles & Components",
  "Bathroom Lighting",
  "Bidet Toilet Faucets",
  "Centerset Faucets",
  "Commercial Bathroom Faucets",
  "Commercial Components",
  "Commercial Fittings Parts",
  "Commercial Spare Parts",
  "Diverter Valves & Trims",
  "Elongated Toilet Seats",
  "Floor Mounted Tub Fillers",
  "Grab Bars",
  "GROHE Blue Accessories",
  "Hand Showers & Accessories",
  "Manual Flush Valves",
  "Other Bathroom Fittings and Parts",
  "Other Commercial Parts",
  "Other Kitchen Accessories",
  "Pot Fillers",
  "Pressure Balance Valves & Trims",
  "Rain Shower Heads",
  "Robe Hooks",
  "Roman Tub Faucets",
  "Rough In Valves",
  "Rough Valve Spare Parts",
  "Sense & Guard Water Security",
  "Shower Body Sprays",
  "Shower Bundle 1June",
  "Shower Heads",
  "Shower System Parts",
  "Shower System Spare Parts",
  "Shower Systems",
  "Shower Systems & Retro-Fit",
  "Shower Trim Kits Parts",
  "Single Hole Faucets",
  "Single Hole Pull Down Faucets",
  "Single Hole Pull Out Faucets",
  "Single Hole Semi Pro Faucets",
  "Soap Dishes & Holders",
  "Soap Dispensers",
  "Thermostatic Valves & Trims",
  "Toilet Brush",
  "Toilet Paper Holders",
  "Toilet Parts",
  "Toilets & Components",
  "Towel Bars",
  "Towel Rings",
  "Trim Kit Fittings and Parts",
  "Tub Fillers",
  "Undermount Sinks",
  "Vessel Faucets",
  "Wall Carrier Flush Valves",
  "Wall Hung Sinks",
  "Wall Mounted Bathroom Faucet",
  "Wall Plate Components",
  "Wall Plates",
  "Widespread Faucets"
]

const allAvailableCategories = [
  "Bathroom Accessories",
  "Bathroom Sink Faucets",
  "Bathroom Sinks",
  "Bathtub Faucets",
  "Kitchen Faucets",
  "Showers",
  "Toilets",
  "Wall Carriers"
]

export const getPartIdFromLixilCategoryName = (categoryName) => {
  if (!categoryName) {
    return ""
  }
  categoryName = categoryName.replace(/-/gi, " ").replace(/list/gi, ""); // Single-Hole-Faucets || Single-Hole-Faucets-list -> Single Hole Faucets
  let parsedCatName = capitalizeFirstLetters(decodeURIComponent(categoryName)).trim();
  if (!allAvailableSubCategories.includes(parsedCatName) && !allAvailableCategories.includes(parsedCatName)) {
    return ""
  }
  switch (parsedCatName) {
    // CATEGORIES
    case "Bathroom Accessories":
      return "paper_holder"
    case "Bathtub Faucets":
      return "bathtub_fixture"
    case "Bathroom Sinks":
      return "vanity_sink"
    case "Bathroom Sink Faucets":
    case "Kitchen Faucets":
      return "vanity_faucet"
    case "Showers":
      return "shower_fixture"
    case "Toilets":
      return "toilet"
    case "Wall Carriers":
      return "left_wall"
    // SUB CATEGORIES
    case "Single Hole Faucets":
    case "Single Hole Pull Down Faucets":
    case "Single Hole Pull Out Faucets":
    case "Single Hole Semi Pro Faucets":
    case "Centerset Faucets":
    case "Commercial Bathroom Faucets":
    case "Bar Centerset Faucets":
    case "Bar Faucets":
    case "Bathroom Faucet Fittings and Spare Parts":
    case "Bathroom Faucet Handles & Components":
    case "Vessel Faucets":
    case "Widespread Faucets":
      return "vanity_faucet"
    case "Wall Mounted Bathroom Faucet":
    case "Roman Tub Faucets":
      return "bathtub_fixture"
    case "Bath Shower Trim Kits":
    case "Trim Kit Fittings and Parts":
      return "trim_kits"
    case "Grab Bars":
      return "grab_bar"
    case "Robe Hooks":
      return "robe_hook"
    case "Rain Shower Heads":
      return "shower_head"
    case "Shower Bundle 1June":
    case "Shower Body Sprays":
    case "Shower Heads":
    case "Shower System Parts":
    case "Shower System Spare Parts":
    case "Shower Systems":
    case "Shower Systems & Retro-Fit":
    case "Shower Trim Kits Parts":
      return "shower_fixture"
    case "Soap Dishes & Holders":
    case "Soap Dispensers":
      return "soap_dish"
    case "Toilet Brush":
      return "toilet_brush"
    case "Toilet Paper Holder":
      return "paper_holder"
    case "Toilet Parts":
    case "Toilet Paper Holders":
    case "Toilets & Components":
      return "toilet"
    case "Towel Bars":
      return "towel_bar"
    case "Towel Rings":
      return "towel_ring"
    case "Undermount Sinks":
    case "Wall Hung Sinks":
      return "vanity_sink"
    default:
      return ""
  }
}
